import React from 'react'
import { RadioGroup } from '../../RadioGroup'
import { RadioOption } from '../../RadioOption'

interface Props extends React.ComponentProps<typeof RadioGroup> {
  options: React.ComponentProps<typeof RadioOption>[]
}

export const RadioGroupWrapper = ({ options, ...props }: Props) => {
  return (
    <RadioGroup {...props}>
      {options.map(option => (
        <RadioOption key={option.value} {...option} />
      ))}
    </RadioGroup>
  )
}
